var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vimeo",class:{ disabled: _vm.disabled }},[_c('div',{staticClass:"vimeo__player",attrs:{"id":"video-iframe","data-vimeo-url":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }